import ScrollReveal from '../ScrollReveal';
import { t } from '@/data/translations';
import type { Lang } from '@/pages/Index';
import type { EducationData } from '@/data/translations';

interface EducationItemProps extends EducationData {
  delay?: number;
}

const EducationItem = ({ year, degree, institution, note, delay = 0 }: EducationItemProps) => (
  <ScrollReveal delay={delay}>
    <article className="py-8 border-t border-border">
      <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8">
        <p className="text-sm text-muted-foreground md:w-32 flex-shrink-0">{year}</p>
        <div>
          <h3 className="text-lg font-medium text-foreground">{degree}</h3>
          <p className="text-base text-muted-foreground">{institution}</p>
          {note && <p className="text-sm text-muted-foreground/70 italic mt-1">{note}</p>}
        </div>
      </div>
    </article>
  </ScrollReveal>
);

const Education = ({ lang }: { lang: Lang }) => {
  const tr = t(lang).education;
  return (
    <section id="education" className="py-24 md:py-32 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto">
        <ScrollReveal>
          <div className="section-divider mb-8" />
        </ScrollReveal>
        <ScrollReveal delay={100}>
          <h2 className="text-sm tracking-widest uppercase text-muted-foreground mb-12">{tr.sectionTitle}</h2>
        </ScrollReveal>
        <div>
          {tr.items.map((edu, index) => (
            <EducationItem key={index} {...edu} delay={(index + 1) * 100} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
